export default "__VITE_ASSET__DEBsvhn2__"